import { useEffect } from "react";
import { IHook } from "./homeTwitter.types";

export const useHomeTwitter: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
